<template>
  <v-dialog 
    persistent 
    scrollable 
    :model-value="true" 
    :scrim="'#212121'"
    :opacity="0.65"
    class="order-complete-modal"
    >
    <v-card class="order-complete-modal order-complete-modal__card">
      <v-card-title class="pa-5 flex-column v-header--fixed">
        <div class="text-center" style="width: 100%">
          <h4>
            Your order has been received.
          </h4>
        </div>
      </v-card-title>
      <v-card-text class="text-center py-4 pt-0">
        You will be sent an email full of your order details. You will now be
        redirected to the rewards history page.
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OrderComplete',
  methods: {
    ...mapActions('cartAssignments', ['resetAssignments'])
  },
  mounted() {
    // clear cart assignments so it will rehit the /redeem && the store
    this.resetAssignments();
    const storageKeys = Object.keys(sessionStorage);
    // Delete all 'vuex-'
    storageKeys.forEach(key => {
      if (/^vuex-/.test(key)) sessionStorage.removeItem(key);
    });
  }
};
</script>

<style lang="scss" scoped>
  :deep(.v-card-text) {
    color: rgba(0, 0, 0, .6) !important;
    font-size: 0.875rem !important;
    font-weight: 400;
    letter-spacing: 0.0178571429em !important;
    line-height: 1.25rem;
  }
	.v-dialog {
		width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
		width: 100%;
	}

	.order-complete-modal {  
	  &__card {
		max-width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
		max-height: 94%;
		margin: 0;
		border-radius: 2rem !important;
	  }
    
    h4 {
      font-size: 1.125rem !important;
      line-height: 1.375rem !important;
      padding-bottom: 4px;
    }
	}

	:deep(.v-overlay__content) {  
	  max-height: calc(100vh - 48px);
	  max-width: min(480px, calc(100vw - 48px));
	}
</style>
